// extracted by mini-css-extract-plugin
export default {"button":"ol-z","reviewSort":"pl-z"};